import styled from "styled-components";
import {JackpotToastTitleAnimatedDefaultBox} from "./jackpot-toast-title-animated.default.box";

export const JackpotToastTitleAnimatedMrGreenBox = styled(JackpotToastTitleAnimatedDefaultBox)`
    font-weight: 600;
    /* TODO: After the MrG rebranding the color #DDDCAA should come from theme */
    color: #DDDCAA;
`;
